import React from 'react';
import clsx from 'clsx';

const BADGE_FLOATING = 'pointer-events-none absolute -top-2.5 whitespace-nowrap shadow-sm';

export const BADGE_ON_TOP = clsx(BADGE_FLOATING, 'right-0');

export const BADGE_ON_TOP_CENTER = clsx(BADGE_FLOATING, 'left-1/2 -translate-x-1/2');

interface Props {
  children: React.ReactNode;
  className?: string;
}

const Badge: React.FC<Props> = ({ children, className }) => (
  <span
    className={clsx(
      'inline-flex items-center rounded-full bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-700',
      className
    )}
  >
    {children}
  </span>
);

export default Badge;
